import { Constants } from '@/constants';
import type { ProjectModuleConfigDto, ProjectModuleDto, ProjectModuleHeroConfigDto } from '@/services/types/api.types';
import type { BlockParent, ModuleTypeOption } from '@/types/modules';

export const blockParentOf = (block: ProjectModuleDto): BlockParent => ({
  type: block.parent_type,
  id: block.parent_id,
});

// A new block starts as Text, which its parent's theme may not offer, as a page's does not: it then starts as the first
// type offered. While none is, as while the parent's theme loads, it keeps its own.
export const offeredBlockType = (offered: Pick<ModuleTypeOption, 'value'>[], blockType: number): number =>
  offered.some((option) => option.value === blockType) ? blockType : (offered[0]?.value ?? blockType);

/** A block type's name among the given types, or its value for a type the admin does not know, never a blank. */
export const blockTypeName = (types: ModuleTypeOption[], blockType: number): string =>
  types.find((type) => type.value === blockType)?.label ?? String(blockType);

// A Hero's project toggles take its title and image from its project and list it in the project's table of contents.
// They mean nothing on a page, yet would still hide a page Hero's title, content and image: a page Hero is edited with
// them off, so its next save writes them off.
export const editableBlockConfig = (block: ProjectModuleDto): ProjectModuleConfigDto => {
  if (block.parent_type !== Constants.Block.ParentType.Page || block.block_type !== Constants.Block.Type.Hero) {
    return block.config;
  }
  return {
    ...block.config,
    useProjectTitle: false,
    includeInTableOfContents: false,
    useProjectImage: false,
  } as ProjectModuleHeroConfigDto;
};
